import React from "react";
import Login from "./components/Login/Login";
import "./App.css";

function App() {
  return (
    <React.Fragment>
      <Login />
    </React.Fragment>
  );
}

export default App;
